// extracted by mini-css-extract-plugin
module.exports = {"actions":"RolesActionsCell_actions_21l4e","error":"RolesActionsCell_error_2M_5o"};